/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Track } from './Track';
import {
    TrackFromJSON,
    TrackFromJSONTyped,
    TrackToJSON,
} from './Track';

/**
 * 
 * @export
 * @interface RemixesResponseData
 */
export interface RemixesResponseData {
    /**
     * 
     * @type {number}
     * @memberof RemixesResponseData
     */
    count: number;
    /**
     * 
     * @type {Array<Track>}
     * @memberof RemixesResponseData
     */
    tracks?: Array<Track>;
}

/**
 * Check if a given object implements the RemixesResponseData interface.
 */
export function instanceOfRemixesResponseData(value: object): value is RemixesResponseData {
    let isInstance = true;
    isInstance = isInstance && "count" in value && value["count"] !== undefined;

    return isInstance;
}

export function RemixesResponseDataFromJSON(json: any): RemixesResponseData {
    return RemixesResponseDataFromJSONTyped(json, false);
}

export function RemixesResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemixesResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'tracks': !exists(json, 'tracks') ? undefined : ((json['tracks'] as Array<any>).map(TrackFromJSON)),
    };
}

export function RemixesResponseDataToJSON(value?: RemixesResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'tracks': value.tracks === undefined ? undefined : ((value.tracks as Array<any>).map(TrackToJSON)),
    };
}

